module.exports = __webpack_public_path__ + "media/images/countrysquared/ms-dae2569a2f690073db28823bbe64516f.svg";